import React from "react";

import user from "../../Assets/images/user.png";
const TableProfile = ({ url, name }) => {
  return (
    <div className="d-flex align-items-center">
      <div className="imgWrp">
        <img
          src={url || user}
          alt=""
          className="img-fluid rounded-circle me-2"
          style={{ height: 40, width: 40 }}
        />
      </div>
      <p className="m-0 themeBlue fw-sbold">{name?.charAt(0).toUpperCase() + name?.slice(1)}</p>
    </div>
  );
};

export default TableProfile;
